import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mpp-mask-magnets',
  templateUrl: './mask-magnets.component.html',
  styleUrls: ['./mask-magnets.component.scss'],
  standalone: false,
})
export class MaskMagnetsComponent {
  public isEU = environment.isEU;

  constructor(private dialogRef: MatDialogRef<MaskMagnetsComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
